import React, { useRef } from 'react';
import { Heading } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
// import useInView from "react-cool-inview";

interface HeadingComponentProps {
	idx: number;
	type?: string;
	heading?: string;
}

const HeadingComponent = ({ idx, type, heading }: HeadingComponentProps) => {
	return (
		<Heading
			pt={idx === 0 ? { base: '16px', md: '40px' } : '0px'}
			key={idx}
			as="h3"
			fontSize="ms-24"
			fontWeight={700}
			color="ms-red.900"
			textAlign={{ base: 'center', md: 'left' }}
			id={type}
			sx={{ scrollMarginTop: '100px' }}
			paddingBottom={{ base: '16px' }}
		>
			{heading}
		</Heading>
	);
};

export { HeadingComponent };
